// Languages supported for AI generation + book metadata.
// Indian languages first, then international.
export const LANGUAGES = [
  // Indian
  { code: "hi", label: "Hindi (हिन्दी)", group: "Indian" },
  { code: "ta", label: "Tamil (தமிழ்)", group: "Indian" },
  { code: "te", label: "Telugu (తెలుగు)", group: "Indian" },
  { code: "bn", label: "Bengali (বাংলা)", group: "Indian" },
  { code: "mr", label: "Marathi (मराठी)", group: "Indian" },
  { code: "gu", label: "Gujarati (ગુજરાતી)", group: "Indian" },
  { code: "kn", label: "Kannada (ಕನ್ನಡ)", group: "Indian" },
  { code: "ml", label: "Malayalam (മലയാളം)", group: "Indian" },
  { code: "pa", label: "Punjabi (ਪੰਜਾਬੀ)", group: "Indian" },
  { code: "ur", label: "Urdu (اردو)", group: "Indian" },
  // International
  { code: "en", label: "English", group: "International" },
  { code: "es", label: "Spanish (Español)", group: "International" },
  { code: "fr", label: "French (Français)", group: "International" },
  { code: "de", label: "German (Deutsch)", group: "International" },
  { code: "it", label: "Italian (Italiano)", group: "International" },
  { code: "pt", label: "Portuguese (Português)", group: "International" },
  { code: "ja", label: "Japanese (日本語)", group: "International" },
  { code: "ko", label: "Korean (한국어)", group: "International" },
  { code: "zh", label: "Chinese (中文)", group: "International" },
  { code: "ar", label: "Arabic (العربية)", group: "International" },
  { code: "ru", label: "Russian (Русский)", group: "International" },
];

export const LANGUAGE_LABEL = LANGUAGES.reduce((acc, l) => {
  acc[l.code] = l.label;
  return acc;
}, {});

export function languageLabel(code) {
  return LANGUAGE_LABEL[code] || "English";
}
